import * as React from "react";
import classnames from "classnames";
import { useIsClient } from "@grandvisionhq/lib-utils-react";
import { getIconByName } from "../../get-icon-by-name.js";
/* empty css          */
const defaultWidth = 24;
const defaultHeight = 24;
const Icon = ({
  name = "",
  width = defaultWidth,
  height = defaultHeight,
  viewBox = `0 0 ${defaultWidth} ${defaultHeight}`,
  className,
  style,
  ...rest
}) => {
  const isClient = useIsClient();
  const classname = classnames("icon", `icon--${name}`, className);
  const fallback = /* @__PURE__ */ React.createElement("div", { className: classname, style: { width, height } });
  const IconByName = getIconByName(name);
  if (!IconByName || !isClient) {
    return fallback;
  }
  return /* @__PURE__ */ React.createElement(React.Suspense, { fallback }, /* @__PURE__ */ React.createElement(
    IconByName,
    {
      style,
      viewBox,
      width,
      height,
      className: classname,
      "data-t": rest["data-t"],
      "aria-hidden": "true",
      role: "img",
      alt: "",
      ...rest
    }
  ));
};
export {
  Icon as default
};
//# sourceMappingURL=Icon.js.map
